import { useSelector } from "react-redux";
import {
  getCalculatedHotspotCoordinates,
  getCurrentStep,
  getTemplate,
} from "../../redux/selectors";
import { steps } from "../../util/constants";
import { useRef } from "react";
import LocationModeHotspot from "./LocationModeHotspot";
import { NormalModeHotspot } from "./NormalModeHotspot";

function HotSpotContainer({ hotspotIndex }) {
  const ref = useRef();
  const currentStep = useSelector(getCurrentStep);
  const template = useSelector((state) => getTemplate(state, { hotspotIndex }));
  const coordinates = useSelector((state) =>
    getCalculatedHotspotCoordinates(state, { hotspotIndex })
  );

  return [steps.configureLocations].includes(currentStep) ? (
    <LocationModeHotspot
      hotspotIndex={hotspotIndex}
      ref={ref}
      coordinates={coordinates}
      template={template}
    />
  ) : (
    <NormalModeHotspot
      hotspotIndex={hotspotIndex}
      ref={ref}
      coordinates={coordinates}
      template={template}
    />
  );
}

export default HotSpotContainer;
